export const ConditionOperators = Object.freeze({
  EQUALS: 'EQUALS',
  GREATER_THAN: 'GREATER_THAN',
  LESS_THAN: 'LESS_THAN',
  GREATER_THAN_EQUALS: 'GREATER_THAN_EQUALS',
  LESS_THAN_EQUALS: 'LESS_THAN_EQUALS',
  BETWEEN: 'BETWEEN',
});
